import React, { Component } from 'react';
import Main from './components/MainComponent';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigureStore } from './redux/configureStore';
import { PersistGate }  from  'redux-persist/es/integration/react';
import { Loading } from './components/LoadingComponent';
import { SignInHeader, SignInFooter } from './components/LoginComponent';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';

//Provider allows to configure react app such that store is available to all components.
const lan_dict = {
    'es': {
        'Sign In': "Ingresar",
        'Sign Up': "Regístrate",
        'Sign in to your account': "INVESTMENT MANAGEMENT",
        'Username': "Usuario",
        "Enter your Username":"Ingresa tu usuario",
        "Enter your username":"Ingresa tu usuario",
        "Reset Password":"Reset contraseña",
        'Password': "Contraseña",
        "Enter your Password":"Ingresa tu contraseña",
        "Forgot your password?":"¿Olvidaste tu contraseña?",
        "Send code": "Enviar código",
        "Back to Sign In": "Regresar",
        "No account?": "¿No tienes cuenta?",
        "Create Account":"Crear cuenta",
        "Create a new account": "Crear nueva cuenta",
        "Email Address *": "Email",
        "Phone Number *": "Telefono",
        "Have an account?": "¿Tienes cuenta?",
        "Sign in":"Iniciar sesión",
        "SignUp is not permitted for this user pool": "Creación de usuarios no permitida",
        "User does not exist.": "Usuario no existe.",
        "Incorrect username or password.":"Usuario o clave incorrecta."
    }
};

I18n.putVocabularies(lan_dict);
I18n.setLanguage('es');

const { persistor, store } = ConfigureStore();

class App extends Component {
  render() {
    return (
      <div className='App'>
        <Provider store={store}>
          <PersistGate
            loading={<Loading />}
            persistor={persistor}
           >
            <BrowserRouter>
              <div>
                <Main />
              </div>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </div>
    );
  }
}


export default withAuthenticator(App, {
  components: {
    SignIn: {
      Header: SignInHeader,
      Footer: SignInFooter
    },
  },
  hideSignUp: true
});
